import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.trading_data.document_uploader.title',
        defaultMessage: 'Upload {documentType}'
    },
    bankStatementGuidance: {
        id: '_.trading_data.document_uploader.bank_statement_guidance',
        defaultMessage:
            "It's important bank statements include transactions from the last 12 months up until as recently as possible - ideally last week."
    },
    bankStatementsForMonths: {
        id: '_.trading_data.document_uploader.bank_statements_for_months',
        defaultMessage:
            'We require all transactions from the past {months} months (from today)'
    },
    acceptanceInfoOne: {
        id: '_.trading_data.document_uploader.acceptance_info_one',
        defaultMessage:
            'We accept PDF, JPG, JPEG and PNG files no more than 2GB.'
    },
    acceptanceInfoTwo: {
        id: '_.trading_data.document_uploader.acceptance_info_two',
        defaultMessage:
            'These should be for the account(s) where the majority of your business revenue is generated.'
    },
    acceptanceInfoThree: {
        id: '_.trading_data.document_uploader.acceptance_info_three',
        defaultMessage:
            'Please ensure the statements display the business name, sort code, account number and the account balance.'
    },
    dragAndDropMessage: {
        id: '_.trading_data.document_uploader.drag_and_drop',
        defaultMessage:
            'Drag & drop file or return it via email to documents@iwoca.co.uk'
    },
    browseFile: {
        id: '_.trading_data.document_uploader.browse_file',
        defaultMessage: 'Browse'
    },
    back: {
        id: '_.trading_data.document_uploader.back',
        defaultMessage: 'Back'
    },
    finish: {
        id: '_.trading_data.document_uploader.finish',
        defaultMessage: 'Finish'
    },
    uploadingDocument: {
        id: '_.trading_data.document_uploader.uploading_document',
        defaultMessage: 'Uploading {document}'
    },
    uploadedDocument: {
        id: '_.trading_data.document_uploader.uploaded_document',
        defaultMessage: 'Uploaded {document}'
    },
    failedDocument: {
        id: '_.trading_data.document_uploader.failed_document',
        defaultMessage: 'Failed to upload {document}'
    },
    DuplicateDocumentError: {
        id: '_.trading_data.document_uploader.failed_document_error.DuplicateDocument',
        defaultMessage: 'The submitted document already exists'
    },
    DocumentUploadError: {
        id: '_.trading_data.document_uploader.failed_document_error.DocumentUpload',
        defaultMessage: 'Document upload failed. Please try again later.'
    }
});
